import { Component, OnInit } from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Router} from "@angular/router";
import Swal from 'sweetalert2'
import { UserService } from 'src/app/services/user.service';
import { disableDebugTools } from '@angular/platform-browser';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit{
  nro_cuenta: any = localStorage.getItem('cuenta');
  nro_cli: any = localStorage.getItem('nro_cliente');
  nro_prov: any = localStorage.getItem('nro_proveedor');
  email: any = '';
  repEmail: any = '';
  password: any = '';
  repPassword: any = '';
  celular: any = '';
  telefono: any = '';
  editMail:boolean=false;
  editPass:boolean=false;

  
  constructor(public userService:UserService, public httpClient:HttpClient, private router: Router) {};

  emailFormControl = new FormControl('', [Validators.required, Validators.email]); 
  repemailFormControl = new FormControl('', [Validators.required, Validators.email]); 

  ngOnInit(): void {
    this.consulUser();

    if(localStorage.getItem('nro_cliente')===''&&localStorage.getItem('nro_proveedor')===''){
      this.router.navigate(['login']);
    }
  }

  consulUser(){
    this.userService.consulUser(this.nro_cuenta,this.nro_cli,this.nro_prov)
    .then((data:any)=>{
       this.email= data.mail;
       this.telefono= data.telefono;
       this.celular= data.celular;
  })
  }

  editarPass(){
    this.editPass = true;
  }

  editarMail(){
    this.editMail = true;
    this.email= '';
  }

  setUsuario(){
    if(this.editMail == false){
      this.repEmail = this.email
    }
    if(this.containsSpecialChars(this.password)){
      Swal.fire({
        title: 'Oops...',
        html: "La contrase&ntilde;a tiene car&aacute;cter no permitido, por favor verifique."
      });
      return;
    }

     this.userService.actualizarUsuario(this.nro_cuenta, this.nro_cli,this.nro_prov,this.email,this.repEmail,this.password,this.repPassword,this.celular,this.telefono)
    .then((data:any)=>{
      if(parseInt(data.error)) {
        //ACA VA LA ALERTA!! :)
        Swal.fire({
          title: 'Oops...',
          text: data.mensaje ,
          footer: '<a href="">Olvidaste tu contraseña?</a>'
        })
      } else {
        Swal.fire({
          title: 'Registro exitoso!',
          text: data[0].msj 
        });
        this.consulUser();
        this.editMail=false;
        this.editPass=false;      
        this.repEmail = ''; 
        this.password = '';
        this.repPassword = '';
      }
  })

  }





    // actuaPerfil():void{
    //   console.log({
    //     'email': this.email,
    //     'repEmail': this.repEmail,
    //     'pass': this.password,
    //     'repPass': this.repPassword,
    //     'cel1': this.celular1,
    //     'cel2': this.celular2
    //   });
      
    // }

    containsSpecialChars(value: string): boolean {
      const regex = /[=!^'"\\<>-]/;
      return regex.test(value);
    }

}
